import { FaReact, FaNode, FaNpm, FaGit } from 'react-icons/fa';
import {
  SiJavascript,
  SiRedux,
  SiMongodb,
  SiExpress,
  SiPostman,
  SiYarn,
  SiNextdotjs,
  SiVisualstudiocode,
  SiLinux,
  SiMaterialui,
  SiNetlify,
  SiCsswizardry,
  SiHeroku,
} from 'react-icons/si';
import { DiGithubFull } from 'react-icons/di';

export const technologies = [
  { id: 1, icon: <SiMongodb /> },
  { id: 2, icon: <SiExpress /> },
  { id: 3, icon: <FaReact /> },
  { id: 4, icon: <FaNode /> },
  { id: 5, icon: <SiRedux /> },
  { id: 6, icon: <SiJavascript /> },
  { id: 7, icon: <SiNextdotjs /> },
  { id: 8, icon: <DiGithubFull /> },
  { id: 9, icon: <SiYarn /> },
  { id: 10, icon: <FaNpm /> },
  { id: 11, icon: <SiPostman /> },
  { id: 12, icon: <FaGit /> },
  { id: 13, icon: <SiVisualstudiocode /> },
  { id: 14, icon: <SiLinux /> },
  { id: 15, icon: <SiMaterialui /> },
  { id: 16, icon: <SiNetlify /> },
  { id: 17, icon: <SiCsswizardry /> },
  { id: 18, icon: <SiHeroku /> },
];
